import React from 'react'

const SectionSix = (props) => {
    const { handleButtonClick, setSelectedOptions, selectedOptions, toggleOption, setMessageBoard, setErrorTabEnable, setWorkOrderTab } = props
    return (
        <>
            <div className="error-message-head1">Check the issue status</div>
            <div className="error-message-head2">
                Check if the issue is resolved
            </div>
            <div style={{ gap: "8px", display: "flex", marginTop: "22px" }}>
                <button
                    onClick={() => {
                        handleButtonClick(6, "yes");
                        setMessageBoard(false);
                        setErrorTabEnable(false);
                    }}
                    className={`error-button ${toggleOption[6] === "yes" ? "clicked" : ""
                        }`}
                    disabled={selectedOptions[6]}
                >
                    Yes
                </button>
                <button
                    onClick={() => {
                        handleButtonClick(6, "no");
                        setSelectedOptions([true, true, true, true, true, true, true]);
                    }}
                    className={`error-button ${toggleOption[6] === "no" ? "clicked" : ""
                        }`}
                    disabled={selectedOptions[6]}
                >
                    No
                </button>
            </div>
            <div style={{ fontSize: "12px" }} className="error-message-head2">
                If issue persists - Raise FR WO
            </div>
            <div className="error-message-head1">Call Logs</div>
            <button
                onClick={() => {
                    setWorkOrderTab(true);
                    setErrorTabEnable(false);
                }}
                style={{
                    background: "#D02F92",
                    border: "1px solid white",
                    borderRadius: "5px",
                    color: "white",
                    width: "40%",
                    fontSize: "12px",
                    cursor: "pointer",
                    height: "4vh",
                    marginTop: "12px",
                }}
            >
                Create Work Order
            </button>

            {/* <div className="error-message-head2">
    Request subscriber to perform reconnection procedure (switch off power supply, wait for 10 seconds and then switch on the power supply)
    </div> */}
        </>
    )
}

export default SectionSix
